import { defineStore } from 'pinia'
import { useAuthStore } from '@sto/auth.store'
import {shallowRef} from "vue";

import * as SupportTicketService from '@ser/support_ticket'

import SupportTicketListTab from "@par/support/SupportTicketListTab.vue"
import SupportTicketCreateTab from "@par/support/SupportTicketCreateTab.vue"


export const useSupportStore = defineStore('support', {

    state: () => {
        return {
            _auth_store: useAuthStore(),
            _panel_active: false,
            _tab_manager: {
                active_tab: 'support_ticket_list',
                tabs: [
                    {
                        key: 'support_ticket_list',
                        label: 'My Support Tickets',
                        component: shallowRef(SupportTicketListTab),
                        roles: ['USER_ORGANISATION_AUCTIONEER']
                    },
                    {
                        key: 'support_ticket_create',
                        label: 'Create a Support Ticket',
                        component: shallowRef(SupportTicketCreateTab),
                        roles: ['USER_ORGANISATION_AUCTIONEER']
                    },
                ]
            }
        }
    },

    getters: {
        panel_active: state => state._panel_active,
        tab_manager: state => state._tab_manager,
        tabs: state => state._tab_manager.tabs,
        active_tab: state => state._tab_manager.tabs.find(tab => tab.key === state._tab_manager.active_tab)
    },

    actions: {

        activateTab(tab_key) {
            if (!this._tab_manager.tabs.map(({key}) => key).includes(tab_key)) return
            this._tab_manager.active_tab = tab_key
        },

        resetStore() {
            this._panel_active = false
        },

        togglePanel() {
            this._panel_active = !this._panel_active
        },

        openPanel(active_tab_key = null) {
            this.activateTab(active_tab_key)
            this._panel_active = true
        },

        closePanel() {
            this._panel_active = false
        },

        /**
         * list support tickets
         * @param params
         * @returns {Promise<promise>}
         */
        async list(params) {
            return SupportTicketService.list(params)
        },

        /**
         * show a single support ticket
         * @param support_ticket_id
         * @returns {Promise<obj>}
         */
        async show(support_ticket_id) {
            return SupportTicketService.show(support_ticket_id)
        },

        /**
         * create a support ticket
         * @param data
         * @returns {Promise<obj>}
         */
        async create(data) {
            return SupportTicketService.create(data)
        },

        /**
         * Update support ticket.
         *
         * @param {number} support_ticket_id - The ID of the support ticket to be updated.
         * @param {object} data - The new information to update the support ticket with.
         *
         * @returns {Promise<object>} - A Promise that resolves with the updated support ticket object if successful.
         */
        async update(support_ticket_id, data) {
            return SupportTicketService.update(support_ticket_id, data)
        },

        async addMedia(support_ticket_id, data){
            return SupportTicketService.addMedia(support_ticket_id, data)
        }
    }

})